import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { BlurRow } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Row/BlurRow'
import { UpsellExpensesButton } from 'modules/finance/components/FinancialWorkspace/components/UpsellExpenses'
import { useFinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'
import { UpsellProps } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/Table/components/types'

export const ExpensesUpsell = ({ headerLength, tableHeadRef, level }: UpsellProps) => {
  const {
    modules: { expenses },
  } = useFinancialWorkspaceAvailabilities()

  return (
    <BlurRow
      title={i18n.t('finance.financial_workspace.employee_costs.upsells.expenses.header')}
      rows={4}
      columns={headerLength}
      tableHeadRef={tableHeadRef}
      level={level}
      titleIcon={expenses ? undefined : 'lock-locked'}
      dataTestId="expenses-table-upsell"
      expandedByDefault
    >
      <Box justifyContent="center" alignItems="center" gap="s12">
        <Text.Normal size="200" weight="semibold" color="textPrimary">
          {i18n.t('finance.financial_workspace.employee_costs.upsells.expenses.title')}
        </Text.Normal>
        <Text.Normal size="200">
          {i18n.t('finance.financial_workspace.employee_costs.upsells.expenses.description')}
        </Text.Normal>
        <UpsellExpensesButton requestComponent="Employee Costs Table" />
      </Box>
    </BlurRow>
  )
}
